/**
 * @generated SignedSource<<5337e08f4a6e3693b40b3f92c8241db8>>
 * @relayHash bc0a11e2d247719800de1eb6e77c7c87
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 12730951e32e781c2e6ae674a94e143040f31ada508e9e2b7d53cf86f2aea40f

import type { ConcreteRequest, Mutation } from 'relay-runtime';
export type JiraSingleValueFieldOperations = "SET" | "%future added value";
export type JiraUpdateCascadingSelectFieldInput = {
  id: string;
  operation: JiraCascadingSelectFieldOperationInput;
};
export type JiraCascadingSelectFieldOperationInput = {
  childOption?: string | null | undefined;
  operation: JiraSingleValueFieldOperations;
  parentOption?: string | null | undefined;
};
export type cascadingSelectField_Mutation$variables = {
  input: JiraUpdateCascadingSelectFieldInput;
};
export type cascadingSelectField_Mutation$data = {
  readonly jira: {
    readonly updateCascadingSelectField: {
      readonly errors: ReadonlyArray<{
        readonly message: string | null | undefined;
      }> | null | undefined;
      readonly success: boolean;
    } | null | undefined;
  } | null | undefined;
};
export type cascadingSelectField_Mutation$rawResponse = {
  readonly jira: {
    readonly updateCascadingSelectField: {
      readonly errors: ReadonlyArray<{
        readonly message: string | null | undefined;
      }> | null | undefined;
      readonly success: boolean;
    } | null | undefined;
  } | null | undefined;
};
export type cascadingSelectField_Mutation = {
  rawResponse: cascadingSelectField_Mutation$rawResponse;
  response: cascadingSelectField_Mutation$data;
  variables: cascadingSelectField_Mutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "concreteType": "JiraMutation",
    "kind": "LinkedField",
    "name": "jira",
    "plural": false,
    "selections": [
      {
        "args": [
          {
            "kind": "Variable",
            "name": "input",
            "variableName": "input"
          }
        ],
        "concreteType": "JiraCascadingSelectFieldPayload",
        "kind": "LinkedField",
        "name": "updateCascadingSelectField",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "success"
          },
          {
            "concreteType": "MutationError",
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "message"
              }
            ]
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "cascadingSelectField_Mutation",
    "selections": (v1/*: any*/),
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "cascadingSelectField_Mutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": "12730951e32e781c2e6ae674a94e143040f31ada508e9e2b7d53cf86f2aea40f",
    "metadata": {},
    "name": "cascadingSelectField_Mutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "30c90a51c8447b75fc86baef709bc308";

export default node;
